import './App.css';
import { motion } from 'framer-motion';
import icp_logo from './icp_logo.png';
import ga_logo from './ga_logo.png';

const tools = [
  { url: 'https://ai-account.site/nextcloud', title: '个人网盘', description: '安全便捷的云端存储空间', cmd: 'mount ~/cloud' },
  { url: 'https://ai-account.site/reference/', title: '命令速查', description: '快速查找和学习各类实用命令', cmd: 'man everything' },
  { url: 'https://ai-account.site/wiki', title: '个人文档', description: '系统化的知识管理与分享平台', cmd: 'cat ~/wiki/*' },
  { url: 'https://ai-account.site/easy-image/', title: '图片仓库', description: '图片存储与分享平台', cmd: 'push image.png' },
  { url: 'https://ai-account.site/notepad/', title: 'AI笔记', description: '临时笔记，随时随地记录灵感', cmd: 'echo >> note.md' },
  { url: 'https://ai-account.site/tools', title: '开发工具箱', description: '常用开发工具集合', cmd: 'ls /usr/bin' },
];

function App() {
  return (
    <div className="App">
      {/* 背景层：网格 + 光晕 + 扫描线 */}
      <div className="bg-grid" aria-hidden="true" />
      <div className="bg-glow" aria-hidden="true" />
      <div className="scanlines" aria-hidden="true" />

      {/* 导航栏 */}
      <nav className="navbar">
        <div className="logo">
          <span className="logo-prompt">~$</span> 命令备忘录
          <span className="logo-cursor" />
        </div>
        <div className="nav-links">
          <a href="#features"><span className="nav-hash">#</span>分类</a>
          <a href="#about"><span className="nav-hash">#</span>关于</a>
          <a href="#contact"><span className="nav-hash">#</span>联系</a>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero">
        <motion.p
          className="hero-kicker"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          [ system ready ] — 6 modules loaded
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          您的<span className="glow-text">命令速查</span>手册
        </motion.h1>
        <motion.div
          className="hero-terminal"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.25 }}
        >
          <span className="prompt">$</span>
          <span className="typing">grep -r "灵感" ~/一切工具</span>
        </motion.div>
        <motion.p
          className="hero-sub"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.45 }}
        >
          快速查找、学习和使用各类常用命令
        </motion.p>
        <motion.a
          href="#features"
          className="cta-button"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          whileHover={{ scale: 1.04 }}
          whileTap={{ scale: 0.97 }}
        >
          ./开始使用 <span className="cta-arrow">↵</span>
        </motion.a>
      </section>

      {/* 特色功能展示 */}
      <section className="features" id="features">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.5 }}
        >
          <span className="h2-decor">{'//'}</span> 常用工具
        </motion.h2>
        <div className="feature-grid">
          {tools.map((item, index) => (
            <motion.a
              href={item.url}
              key={index}
              className="feature-card"
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.5, delay: (index % 3) * 0.12 }}
              whileHover={{ y: -8 }}
            >
              <div className="card-titlebar">
                <span className="dot dot-r" />
                <span className="dot dot-y" />
                <span className="dot dot-g" />
                <span className="card-cmd">{item.cmd}</span>
              </div>
              <div className="card-body">
                <span className="card-index">{String(index + 1).padStart(2, '0')}</span>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
                <span className="feature-link">查看详情 →</span>
              </div>
            </motion.a>
          ))}
        </div>
      </section>

      {/* 页脚 */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>联系我们</h4>
            <p>Email: contact@ai-account.site</p>
          </div>
          <div className="footer-section">
            <h4>快速链接</h4>
            <div className="footer-links">
              <a href="/privacy" className="footer-link">隐私政策</a>
              <a href="/terms" className="footer-link">使用条款</a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 命令备忘录. All rights reserved.</p>
          <div className="beian-container">
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
              className="beian-link"
            >
              <img src={icp_logo} alt="ICP备案" className="beian-icon" />
              赣ICP备2024044024号
            </a>
            <a
              href="https://beian.mps.gov.cn/#/query/webSearch?code=36090202000315"
              target="_blank"
              rel="noopener noreferrer"
              className="beian-link"
            >
              <img src={ga_logo} alt="公安备案" className="beian-icon" />
              赣公网安备36090202000315
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
